import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { CommentWrapper, renderListPoint } from "../common";
import { StagesType, PreInterviewSectionType } from "../../Constants";

const PreInterviewSection = ({
    guideData,
    commentData,
    ...props
}) => {
    const guideLinesData = guideData[StagesType.PRE_INTERVIEW_SETUP]?.sections;

    const renderGeneric = () => {
        let genericGuideData = [];
        guideLinesData?.map( item => {
            if(item?.type === "PRE_INTERVIEW_SETUP") {
                let arr1 = item?.values?.filter(item=>item?.selected) || [];
                genericGuideData = [...arr1];
            }
        })

        return (
            <Box className="instruction-main-wrapper">
                <Typography className="pre-interview-common-head-text">Interview set-up instructions for candidates. These will be sent to candidates via email.</Typography>
                <Box className="preinterview-instruction-wrapper">
                    <Box className="preinterview-inner-wrapper">
                    {
                        genericGuideData && genericGuideData?.map((item, index) => {
                            return renderListPoint(index, `common-text`,item?.label)
                        })
                    }
                    </Box>                    
                </Box>
            </Box>
        )
    }

    return (
        <Box className="guideline-section-main-wrapper">
            {/* Generic Guidelines */}
            <CommentWrapper
            stageType={StagesType.PRE_INTERVIEW_SETUP}
            sectionType={PreInterviewSectionType.PRE_INTERVIEW_SETUP}
            sectionCommentData={commentData?.data?.[StagesType.PRE_INTERVIEW_SETUP]?.[PreInterviewSectionType.PRE_INTERVIEW_SETUP]}
            commentData={commentData}
            {...props}
            >
                {renderGeneric()}
            </CommentWrapper>
        </Box>
    )
}
export default PreInterviewSection;